import { render, staticRenderFns } from "./GJgrowEventCreateBaseSettingDateSpan.vue?vue&type=template&id=7de4c32e&scoped=true&"
import script from "./GJgrowEventCreateBaseSettingDateSpan.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateBaseSettingDateSpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de4c32e",
  null
  
)

export default component.exports